export default __webpack_public_path__ + "static/media/domain-specific.93570657.png";